import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { useFetchGetRef, useSearchParamsState } from '../hooks';
import { BASE_URI } from '../globals';
import { useRegionContext } from '../context/RegionContext';

function RegionWrapper() {
    const { region } = useRegionContext();
    const { refData: elections, setRefUrl: setElectionsUrl } = useFetchGetRef(null, []);
    useEffect(() => {
        if (region) {
            setElectionsUrl(`${BASE_URI}/region/${region}/election/`);
        }
    }, [region]);
    // The default election is the one with the latest date.
    const [defaultElection] = useSearchParamsState(
        'election',
        elections?.sort((a, b) => new Date(b.date) - new Date(a.date))?.[0]
    );
    return <Outlet context={{ election: defaultElection }} />;
}

export default RegionWrapper;
